<template>
	<ToggleGroup
		type="single"
		:model-value="modelValue"
		:spacing="1"
		aria-label="Billing cycle"
		class="gap-0 rounded-md bg-gray-100 px-[3px] py-0.5 md:rounded-t-none md:py-[3px]"
		@update:model-value="select"
	>
		<ToggleGroupItem
			v-for="option in options"
			:key="option.value"
			:value="option.value"
			class="h-auto min-w-0 rounded-sm px-2 py-1 text-sm font-medium text-won-secondary hover:bg-transparent hover:text-gray-900 data-[state=on]:bg-white data-[state=on]:text-gray-900 data-[state=on]:shadow-sm md:px-1.5 md:py-px md:text-xs"
		>
			{{ option.label }}
		</ToggleGroupItem>
	</ToggleGroup>
</template>

<script setup>
import { computed } from 'vue';

import { ToggleGroup, ToggleGroupItem } from '../../ui/toggle-group';
import { BILLING_CYCLE_MONTHLY, BILLING_CYCLE_SIX_MONTH } from '../../../utils/premium-pricing';

/**
 * The Monthly / 6-Month switch on the premium column. 6-Month always comes first (EN-1026).
 */
const props = defineProps({
	modelValue: {
		type: String,
		required: true,
	},
	savePercent: {
		type: Number,
		default: null,
	},
});

const emit = defineEmits(['update:modelValue']);

const options = computed(() => [
	{
		value: BILLING_CYCLE_SIX_MONTH,
		label: props.savePercent ? `6-Month (Save ${props.savePercent}%)` : '6-Month',
	},
	{ value: BILLING_CYCLE_MONTHLY, label: 'Monthly' },
]);

// A single toggle group empties itself when the pressed item is clicked again; a cycle is
// always selected, so keep the current one instead.
const select = (value) => {
	if (value) {
		emit('update:modelValue', value);
	}
};
</script>
